const makePossessive = (name: string = '') => {
  if (!name) {
    return '';
  }

  return name.endsWith('s') ? `${name}'` : `${name}'s`;
};

export default makePossessive;
